var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5102 16.999H8.18604",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98684 5.83354L27.4511 15.5631C27.9947 15.8348 28.3381 16.3903 28.3381 16.998C28.3381 17.6057 27.9947 18.1612 27.4511 18.4329L7.98684 28.1625C7.42282 28.4445 6.74587 28.3701 6.25665 27.9721C5.76743 27.5742 5.55668 26.9266 5.71801 26.317L8.18634 16.998L5.71801 7.67906C5.55668 7.06942 5.76743 6.42181 6.25665 6.02387C6.74587 5.62593 7.42282 5.55146 7.98684 5.83354Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.566ddd8a951b70f81f38453deec99357.svg";
export { ForwardRef as ReactComponent };